import RelatedCalcCard from './RelatedCalcCard';
export default RelatedCalcCard;
